import { normalizeDateString, dayDiff } from '@hero/hero-utils/date';
const getPastDueLabel = (payment_failed_at) => {
    const pastDue = dayDiff(new Date(), normalizeDateString(payment_failed_at));
    if (Number.isNaN(pastDue))
        return '-';
    return `D ${pastDue}`;
};
export default getPastDueLabel;
